module.exports = __webpack_public_path__ + "static/FontAwesome5_Solid-872545dde71de3842234bf6afe80c4cb.ttf";